import { formatFileSize, isDefinedGlobally } from './utils';

const messages = {
  _default: (field) => `${Field} өрісінің мәні жарамсыз`,
  after: (field, [target, inclusion]) => `${field} өрісінде ${inclusion  ? 'немесе тең' : ''}${target}`,
  alpha: (field) => `${field} өрісінде тек әріптер болуы мүмкін`,
  alpha_dash: (field) => `${field} өрісінде тек әріптер, сандар және сызықша болуы мүмкін`,
  alpha_num: (field) => `${field} өрісінде тек әріптер мен сандар болуы мүмкін`,
  alpha_spaces: (field) => `${field} өрісінде тек әріптер мен Бос орындар болуы мүмкін`,
  before: (field, [target, inclusion]) => `${Field} өрісінде $дейін күн болуы керек{inclusion ? 'немесе тең' : ''}${target}`,
  between: (field, [min, max]) => `${field} өрісі ${min} және ${max} арасында болуы керек`,
  confirmed: (field, [confirmedField]) => `${field} өрісі ${confirmedField} өрісіне сәйкес келмейді`,
  credit_card: (field) => `${field} өрісі жарамды карта нөмірі болуы керек`,
  date_between: (field, [min, max]) => `${field} өрісі ${min} және ${max} арасында болуы керек`,
  date_format: (field, [format]) => `${field} өрісі ${format} форматында болуы керек`,
  decimal: (field, [decimals = '*'] = []) => `${field} өрісі сандық болуы керек және`,
  digits: (field, [length]) => `${field} өрісі сандық болуы керек және дәл ${length} сандары болуы керек`,
  dimensions: (field, [width, height]) => `${field} өрісі ${width} пиксель үшін $ {height} пиксель болуы керек`,
  email: (field) => `${field} өрісі жарамды электрондық пошта мекенжайы болуы керек`,
  excluded: (field) => `${field} өрісі жарамды мән болуы керек`,
  ext: (field, [args]) => `${field} өрісі жарамды файл болуы керек (${args})`,
  image: (field) => `${field} кескін болуы керек`,
  included: (field) => `${field} өрісі жарамды мән болуы керек`,
  integer: (field) => `${field} бүтін сан болуы керек`,
  ip: (field) => `${field} өрісі жарамды IP мекенжайы болуы керек`,
  length: (field, [length, max]) => {
    if (max) {
      return `${field} өрісінің ұзындығы ${length} мен ${max} арасында болуы керек`
    }

   return `өрістің ұзындығы ${field} ${length} болуы керек`
  },
  max: (field, [length]) => `${field} өрісі ${length} таңбаларынан артық болмауы мүмкін`,
  max_value: (field, [max]) => `${field} өрісі ${max} немесе одан аз болуы керек`,
  mimes: (field, [args]) => `${field} өрісі жарамды файл түріне ие болуы керек (${args})`,
  min: (field, [length]) => `${field} өрісі ${length} таңбаларынан кем болмауы керек`,
  min_value: (field, [min]) => `${field} ${min} немесе одан да көп болуы керек`,
  numeric: (field) => `${field} өрісі сан болуы керек`,
  regex: (field) => `${field} өрісі қате форматқа ие`,
  required: (field) => `${field} толтыру үшін міндетті`,
  size: (field, [size]) => `${field} өрісі ${formatFileSize (size)}`,
  url: (field) => `${field} өрісінде қате URL пішімі бар`,
  isPhoneValid: (field) => `${field} өрісі жарамды телефон болуы керек!`,
  isEmailUnique: (field) => `мұндай ${field} бар қызметкер жүйеде бұрыннан бар!`,
  isIddUnique: (field) => `мұндай ${field} бар Донор жүйеде бұрыннан бар!`,
  serviceCode: (field) => `${field} өрісінде 3-16 a-Z 0-9 таңбасы болуы керек!`,
  isRoleNameUnique: (field) => `мұндай атаумен рөл жүйеде бұрыннан бар!`,
  isAlleleValid: (field, params, data) => data || "сервермен байланыс қатесі!",
  isBillNumberUnique: (field, params, data) => data || "сервермен байланыс қатесі!",
  isGroupGCodeExist: (field, params, data) => data || "сервермен байланыс қатесі!",
  isLocusGroupValid: (field, params) => `мән өрісі 'жарамды локустар жиынтығы болуы керек!`,
  dateRangeRequired: (field, params) => `${field} өрісі міндетті түрде толтырылуы керек.`,
  isLoginUnique: (field, params) => `мұндай ${field} бар қызметкер жүйеде бұрыннан бар!`,
  positiveNumber: (field, params) => `баға оң сан болуы керек!`,
  isCodeUnique: (field, params) => `мұндай ${field} бар жазба жүйеде бұрыннан бар!`
};

const locale = {
  name: 'kk',
  messages,
  attributes: {}
};

if (isDefinedGlobally()) {
  // eslint-disable-next-line
  VeeValidate.Validator.localize({ [locale.name]: locale });
}

export default locale;
